import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { UploadResumesProcessedCandidatesComponent } from './upload-resumes-processed-candidates.component';
import { SendCandidateOutreachEmailModule } from 'src/app/shared/send-candidate-outreach-email/send-candidate-outreach-email.module';

@NgModule({
  declarations: [UploadResumesProcessedCandidatesComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule.forRoot(),
    PipesModule,
    SendCandidateOutreachEmailModule
  ],
  exports: [UploadResumesProcessedCandidatesComponent],
  entryComponents: [UploadResumesProcessedCandidatesComponent]
})
export class UploadResumesProcessedCandidatesModule { }
